import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Section, Field, Empty, useBusy } from "./common";
import { DeviceList } from "./DeviceList";
import { fmtDateTime } from "../lib/helpers";

const EMPTY = { current_password: "", new_password: "", confirm: "" };

function ChangePassword({ onDone }) {
  const { t } = useLang();
  const [pw, setPw] = useState(EMPTY);
  const [busy, run] = useBusy();
  const ch = (k) => (e) => setPw({ ...pw, [k]: e.target.value });
  const submit = (e) => run(async () => {
    e.preventDefault();
    if (pw.new_password !== pw.confirm) return toast.error(t("Passwords do not match", "Las contraseñas no coinciden"));
    try {
      await api.post("/auth/password", { current_password: pw.current_password, new_password: pw.new_password });
      toast.success(t("Password changed. Other devices were signed out.", "Contraseña cambiada. Se cerró la sesión en los demás dispositivos."));
      setPw(EMPTY);
      onDone();
    } catch (err) { toast.error(errMsg(err)); }
  });
  return (
    <Section title={t("Change password", "Cambiar contraseña")} testid="profile-password-section">
      <form onSubmit={submit} className="p-4 grid gap-3">
        <Field label={t("Current password", "Contraseña actual")}><input className="inp" type="password" required autoComplete="current-password" value={pw.current_password} onChange={ch("current_password")} data-testid="profile-current-password" /></Field>
        <Field label={t("New password (min 8)", "Nueva contraseña (mín 8)")}><input className="inp" type="password" required minLength={8} autoComplete="new-password" value={pw.new_password} onChange={ch("new_password")} data-testid="profile-new-password" /></Field>
        <Field label={t("Confirm new password", "Confirmar nueva contraseña")}><input className="inp" type="password" required minLength={8} autoComplete="new-password" value={pw.confirm} onChange={ch("confirm")} data-testid="profile-confirm-password" /></Field>
        <button className="btn-dark w-full sm:w-fit" disabled={busy} data-testid="profile-change-password-btn">{t("Change password", "Cambiar contraseña")}</button>
        <Link to="/forgot-password" className="text-sm font-semibold text-[#D9531E]" data-testid="profile-forgot-password-link">{t("Forgot your current password? Reset it by email", "¿Olvidó su contraseña actual? Restablézcala por correo")}</Link>
      </form>
    </Section>
  );
}

export function ProfileSecurity() {
  const { t, lang } = useLang();
  const [events, setEvents] = useState([]);
  const load = () => api.get("/me/security-events").then((r) => setEvents(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <div className="grid lg:grid-cols-2 gap-4">
      <ChangePassword onDone={load} />
      <Section title={t("Known devices & active sessions", "Dispositivos conocidos y sesiones activas")} testid="profile-devices-section"><DeviceList /></Section>
      <Section title={t("Recent security activity", "Actividad de seguridad reciente")} testid="profile-security-events">
        {events.length ? events.map((e) => (
          <div key={e.id} className="px-4 py-2 border-b text-sm" data-testid={`security-event-${e.id}`}>
            <div className="mono text-xs text-slate-500">{fmtDateTime(e.created_at, lang)}</div>{e.action}
          </div>
        )) : <Empty text={t("No security events yet", "Sin eventos de seguridad")} />}
      </Section>
    </div>
  );
}
